export default __webpack_public_path__ + "static/media/yeopen_mobile_small@2x.77dbe1d0.jpg";